export default "__VITE_ASSET__VU_kgx0Y__"